import React from "react";
import Select from "react-select";
import { customStyles } from "./selectStyles";

const SelectInput = ({
  placeholderText,
  selectOptions,
  handleChange,
  value,
  defaultValue,
  inputName,
  idName,
  isMulti,
  isClearable,
  isSearchable,
  noOptionsMessage,
  disabled,
  disableText,
  error,
  isRequired,
}) => {
  const formatOptionLabel = ({ label, isDisabled }) => (
    <div className="w-full flex justify-between">
      {label}
      {isDisabled && <span style={{ color: "red" }}>{disableText}</span>}
    </div>
  );

  return (
    <div className={disabled ? "opacity-60 cursor-not-allowed" : ""}>
      <Select
        placeholder={placeholderText}
        options={selectOptions}
        styles={customStyles}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        defaultValue={defaultValue}
        value={value}
        name={inputName}
        inputId={idName}
        onChange={handleChange}
        isMulti={isMulti}
        isClearable={isClearable}
        isSearchable={isSearchable}
        className="select-custom"
        classNamePrefix="select"
        noOptionsMessage={noOptionsMessage}
        formatOptionLabel={formatOptionLabel}
        required={isRequired}
        isDisabled={disabled}
      />
      {error && (
        <div className="error-txt text-[#f00] text-xs mt-1">{error}</div>
      )}
    </div>
  );
};

export default SelectInput;
